import React from 'react';

import SignupGeneratorPageContent from 'components/dashboard/signup-generator-content/SignupGeneratorPageContent';

const DashboardSignupGeneratorPage = () => <SignupGeneratorPageContent />;

export default DashboardSignupGeneratorPage;
